import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EngineeringIcon from '@mui/icons-material/Engineering';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getcontract } from '../redux/contract';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function BasicModal() {
  const dispatch = useDispatch();
  const farmers = useSelector((state) => state.farmer);
  const staff = useSelector((state) => state.staff);
  const service = useSelector((state) => state.service);
  const agents = useSelector((state) => state.agent);

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [farmer, setFarmer] = React.useState("none");
  const [agent, setAgent] = React.useState("none");
  const [inputlist, setInputList] = React.useState("none");
  const [payment, setPayment] = React.useState("none");
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const resetForm = () => {
    const fields = [
      "quantity",
      "unit",
      "expected",
      "actual",
      "yieldunit",
      "amount",
      "qtyBarter",
      "unitBarter",
      "paymentterms",
    ];
    fields.forEach((id) => {
      const element = document.getElementById(id);
      if (element) element.value = "";
    });
    setFarmer("none");
    setAgent("none");
    setInputList("none");
    setPayment("none");
  };

  const validateForm = () => {
    if (farmer === "none") return "Farmer is required";
    if (agent === "none") return "Agent is required";
    if (inputlist === "none") return "Input Requested is required";
    if (payment === "none") return "Payment Type is required";
    if (!document.getElementById("quantity").value || Number(document.getElementById("quantity").value) <= 0)
      return "Valid quantity is required";
    if (!document.getElementById("unit").value) return "Unit is required";
    if (payment === "Cash" && (!document.getElementById("amount").value || Number(document.getElementById("amount").value) <= 0))
      return "Valid amount is required";
    if (payment === "Barter") {
      if (!document.getElementById("qtyBarter").value || Number(document.getElementById("qtyBarter").value) <= 0)
        return "Valid barter quantity is required";
      if (!document.getElementById("unitBarter").value) return "Barter unit is required";
    }
    return null;
  };

  const addContract = async () => {
    const validationError = validateForm();
    if (validationError) {
      handleSnackbarOpen(validationError, "error");
      return;
    }

    setLoading(true);
    const amount = payment === "Cash" ? document.getElementById("amount").value : 0;
    const qtyBarter = payment === "Barter" ? document.getElementById("qtyBarter").value : "";
    const unitBarter = payment === "Barter" ? document.getElementById("unitBarter").value : "";

    try {
      const response = await axios.post("https://server.agrotraciserp.com/api/requisition/addrequisition/", {
        farmer: farmer,
        agent: agent,
        inputlist: inputlist,
        quantity: document.getElementById("quantity").value,
        unit: document.getElementById("unit").value,
        expected: document.getElementById("expected").value,
        actual: document.getElementById("actual").value,
        yieldunit: document.getElementById("yieldunit").value,
        paymenttype: payment,
        amount: amount,
        qtyBarter: qtyBarter,
        unitBarter: unitBarter,
        paymentterms: document.getElementById("paymentterms").value,
      });

      if (response.status === 200) {
        dispatch(getcontract({ data: response.data }));
        handleSnackbarOpen("Contract Added Successfully", "success");
        resetForm();
        handleClose();
      } else {
        handleSnackbarOpen("Failed to Add Contract", "error");
      }
    } catch (err) {
      handleSnackbarOpen("Error Adding Contract", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Request Input
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Request New Contract
          <IconButton onClick={handleClose} sx={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              addContract();
            }}
          >
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Choose Farmer</InputLabel>
              <Select
                value={farmer}
                onChange={(e) => setFarmer(e.target.value)}
                label="Choose Farmer"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                {farmers.map((list) => (
                  <MenuItem key={list.farmername} value={list.farmername}>
                    {list.farmername}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Choose Agent</InputLabel>
              <Select
                value={agent}
                onChange={(e) => setAgent(e.target.value)}
                label="Choose Agent"
                required
              >
               
                <MenuItem value="none">Choose Agent</MenuItem>
                
                {staff.map((list) => (
                  
                  
                  <MenuItem key={`${list.lastname} ${list.othername} ${list.surname}`} value={list.ID}>
                    {`${list.lastname} ${list.othername} ${list.surname}`}
                
                  </MenuItem>
                ))}


{agents && agents.length > 0 && agents.map((list) => (
                  
                  
                  <MenuItem key={`${list.lastname} ${list.othername}`} value={list.ID}>
                    {`${list.lastname} ${list.othername}`}
                
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Input Requested</InputLabel>
              <Select
                value={inputlist}
                onChange={(e) => setInputList(e.target.value)}
                label="Input Requested"
                required
              >
                <MenuItem value="none">Choose Service</MenuItem>
                {service.map((list) => (
                  <MenuItem key={list.servicename} value={list.servicename}>
                    {list.servicename} 
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="quantity"
              label="Quantity"
              type="number"
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              required
            />
            <TextField
              id="unit"
              label="Unit"
              type="text"
              autoComplete="current-text"
              required
            />
            <TextField
              id="expected"
              label="Expected Yield"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="actual"
              label="Actual Yield"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="yieldunit"
              label="Yield Unit"
              type="text"
              autoComplete="current-text"
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Payment Type</InputLabel>
              <Select
                value={payment}
                onChange={(e) => setPayment(e.target.value)}
                label="Payment Type"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Barter">Barter</MenuItem>
              </Select>
            </FormControl>
            {payment === "Cash" ? (
              <TextField
                id="amount"
                label="Amount"
                type="number"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">GHC</InputAdornment>,
                }}
                autoComplete="current-text"
                required
              />
            ) : payment === "Barter" ? (
              <>
                <TextField
                  id="qtyBarter"
                  label="Barter Quantity"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  defaultValue={0}
                  autoComplete="current-text"
                  required
                />
                <TextField
                  id="unitBarter"
                  label="Barter Unit"
                  type="text"
                  autoComplete="current-text"
                  required
                />
              </>
            ) : null}
            <TextField
              id="paymentterms"
              label="Payment Terms"
              type="text"
              autoComplete="current-text"
              sx={{ m: 1, width: '52ch' }}
              helperText="Optional payment terms description"
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Box sx={{ textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" disabled>Loading...</Button>
            ) : (
              <Button
                type="submit"
                variant="outlined"
                startIcon={<EngineeringIcon />}
                size="large"
                sx={{ bgcolor: '#e0eff9', color: '#1976d2' }}
                onClick={addContract}
              >
                Add Contract
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}